import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetDowntimeSummaryReport'
import Component from 'components/Reports/AssetDowntimeSummaryReport'

export default createListViewContainer({ actions, selectors: selectors.assetDowntimeSummaryReport })(Component)
